<template>
    <v-content>

        <div class="banner-phase2bg" v-if="$route.path === '/products-tv' || $route.path === '/'">
            <img class="banner" :src="menu.tvTopbannerPhase2">
        </div>

        <div class="banner-phase2bg" v-if="$route.path === '/products-headphone'">
            <img class="banner" :src="menu.headphoneTopbannerPhase2">
        </div>

        <div class="banner-phase2bg" v-if="$route.path === '/products-sound'">
            <img class="banner" :src="menu.soundTopbannerPhase2" >
        </div>

        <div class="banner-phase2bg" v-if="$route.path === '/products-camera'">
            <img class="banner" :src="menu.cameraTopbannerPhase2">
        </div>

        <div class="banner-phase2bg" v-if="$route.path === '/products-lens'">
            <img class="banner" :src="menu.lensTopbannerPhase2">
        </div>

        <div class="banner-phase2bg" v-if="$route.path === '/products-playstation'">
            <img class="banner" :src="menu.playstationTopbannerPhase2">
        </div>

    </v-content>
</template>

<script>
    export default {
        name: "Topbanner",
        data() {
            return {
                menu: {
                    tvTopbanner: null,
                    tvTopbannerPhase2: null,

                    headphoneTopbanner: null,
                    headphoneTopbannerPhase2: null,

                    soundTopbanner: null,
                    soundTopbannerPhase2: null,

                    cameraTopbanner: null,
                    cameraTopbannerPhase2: null,

                    lensTopbanner: null,
                    lensTopbannerPhase2: null,

                    playstationTopbanner: null,
                    playstationTopbannerPhase2: null,

                },

            }
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        methods: {
            handleResize() {
                let width = window.innerWidth;
                // size mobile
                if (width < 576) {

                    this.size = 'mobile';
                    this.menu.tvTopbanner = require('../assets/banner/Top-banner/mbanner_tv.jpg');
                    this.menu.tvTopbannerPhase2 = require('../assets/banner/Top-banner/banner_sonyday2.jpg');

                    this.menu.headphoneTopbanner = require('../assets/banner/Top-banner/mbanner_headphone.png');
                    this.menu.headphoneTopbannerPhase2 = require('../assets/banner/Top-banner/mbanner_headphone.png');

                    this.menu.soundTopbanner = require('../assets/banner/Top-banner/mbanner_sound.png');
                    this.menu.soundTopbannerPhase2 = require('../assets/banner/Top-banner/mbanner_sound.png');

                    this.menu.cameraTopbanner = require('../assets/banner/Top-banner/mbanner_camera.png');
                    this.menu.cameraTopbannerPhase2 = require('../assets/banner/Top-banner/mbanner_camera.png');

                    this.menu.lensTopbanner = require('../assets/banner/Top-banner/mbanner_lens.png');
                    this.menu.lensTopbannerPhase2 = require('../assets/banner/Top-banner/mbanner_lens.png');

                    this.menu.playstationTopbanner = require('../assets/banner/Top-banner/mbanner_playstation.png');
                    this.menu.playstationTopbannerPhase2 = require('../assets/banner/Top-banner/mbanner_playstation.png');

                } else {

                    this.size = 'desktop';
                    this.menu.tvTopbanner = require('../assets/banner/Top-banner/banner_sonyday.png');
                    this.menu.tvTopbannerPhase2 = require('../assets/banner/Top-banner/banner_sonyday2.jpg');

                    this.menu.headphoneTopbanner = require('../assets/banner/Top-banner/banner_headphone.png');
                    this.menu.headphoneTopbannerPhase2 = require('../assets/banner/Top-banner/head.png');

                    this.menu.soundTopbanner = require('../assets/banner/Top-banner/banner_sound.png');
                    this.menu.soundTopbannerPhase2 = require('../assets/banner/Top-banner/sound.png');

                    this.menu.cameraTopbanner = require('../assets/banner/Top-banner/banner_camera.png');
                    this.menu.cameraTopbannerPhase2 = require('../assets/banner/Top-banner/camera.png');

                    this.menu.lensTopbanner = require('../assets/banner/Top-banner/banner_lens.png');
                    this.menu.lensTopbannerPhase2 = require('../assets/banner/Top-banner/lens.png');

                    this.menu.playstationTopbanner = require('../assets/banner/Top-banner/banner_playstation.png');
                    this.menu.playstationTopbannerPhase2 = require('../assets/banner/Top-banner/play4.png');

                }
            }
        }
    }
</script>

<style scoped>

    .banner {
        width: 100%;
    }

    .banner-phase2bg {
        background-image: url("../assets/banner/Top-banner/bg2.jpg");
        background-size: cover;
        width: 100%;
    }

</style>
